import { cloneElement, Fragment, isValidElement, ReactElement } from "react";
import clsx from "clsx";

// Interfaces
import { ISideTreeBadge } from "../../interfaces";

// MUI
import { Skeleton, Stack, Typography } from "@mui/material";

// Constants
const overLimit = 99;

const isNumericOver = (number: number) => number > overLimit;

const getBadgeLabel = (variant: string, label: string | number) => {
	if (variant === "numeric" && !label) {
		return 0;
	}

	if (isNumericOver(Number(label))) {
		return `${overLimit}+`;
	}

	return label;
};

const getWidth = (label: string | number) => {
	if (!label) {
		return "21px";
	}

	if (String(label).endsWith("+") || String(label).length > 2) {
		return "31px";
	}

	return "21px";
};

export default function SideTreeBadge(props: Readonly<ISideTreeBadge>) {
	const { component = null, sx = null, title = "", variant = "string", disabled = false, loading = false, selected = false } = props;

	if (loading) {
		return (
			<Skeleton
				className={clsx({
					"!bg-white": selected,
				})}
				variant="circular"
				height={21}
				width={21}
			/>
		);
	}

	if (component && Boolean(isValidElement(component))) {
		return <Fragment>{cloneElement(component as ReactElement, { ...props })}</Fragment>;
	}

	const label = getBadgeLabel(variant, title);
	if (!label && variant !== "numeric") {
		return null;
	}

	return (
		<Stack
			className={clsx({
				"rounded-full": true,
				"bg-neutral-gray": !selected && !disabled,
				"bg-white": selected && !disabled,
				"bg-disabled": disabled,
			})}
			width={getWidth(label)}
			height={"21px"}
			alignContent={"end"}
			alignItems={"center"}
			justifyContent={"end"}
			sx={sx}
		>
			<Typography
				className={clsx({
					"!font-sans !text-[14.5px] ": true,
					"!text-white": !selected || disabled,
					"!text-primary": selected && !disabled,
					"opacity-75": disabled,
				})}
			>
				{label}
			</Typography>
		</Stack>
	);
}
